module.exports = __webpack_public_path__ + "static/dreds-2e0c09a5df621b770403b89a867d4889.jpg";